import { Fragment, isValidElement, ReactNode } from 'react';

export const isReactFragment = (child: ReactNode): child is Exclude<ReactNode, typeof Fragment> => {
    return isValidElement(child) && child.type === Fragment;
};
